import type { IProcessStepScreensInfo, IProject } from "@kuika/kuika-cl-model";

export enum EScreenRole {
  none = 0,
  startingScreen = 1,
  signinScreen = 2,
  resetPasswordScreen = 3,
  splashScreen = 5,
  newPasswordScreen = 6,
  verificationScreen = 7,
  offlineScreen = 8,
  processStepScreen = 9,
  extProcessStepScreen = 10,
  documentUploadLinkScreen = 11
}

export const resolveScreenRole = (screenId: string, project: IProject): EScreenRole => {
  if (project.startingScreenId === screenId) return EScreenRole.startingScreen;
  if (project.signinScreenId === screenId) return EScreenRole.signinScreen;
  if (project.resetPasswordScreenId === screenId) return EScreenRole.resetPasswordScreen;
  if (project.splashScreenId === screenId) return EScreenRole.splashScreen;
  if (project.newPasswordScreenId === screenId) return EScreenRole.newPasswordScreen;
  if (project.verificationCodeScreenId === screenId) return EScreenRole.verificationScreen;
  if (project.offlineScreenId === screenId) return EScreenRole.offlineScreen;
  if (project.documentUploadLinkScreenId === screenId) return EScreenRole.documentUploadLinkScreen;
  if (
    project.processStepScreenIds?.find(
      (p: IProcessStepScreensInfo): boolean => p.screenId === screenId && p.projectId === project.id
    )
  )
    return EScreenRole.processStepScreen;
  if (
    project.processStepScreenIds?.find(
      (p: IProcessStepScreensInfo): boolean => p.screenId === screenId && p.projectId !== project.id
    )
  )
    return EScreenRole.processStepScreen;
  return EScreenRole.none;
};
